import {convertPaymentType} from '@/utils';
import {formatAmount, formatRate} from '@/purchase/utils';

/**
 * Mise en forme des données de l'export comptable (dates AAAAMMJJ du FEC, montants, contrôles).
 */

// Date (ou date ISO AAAA-MM-JJ...) -> AAAAMMJJ, le jour étant celui enregistré en base (UTC), comme dans le FEC
export function dateToFec(date) {
    return date ? new Date(date).toISOString().substring(0, 10).replace(/-/g, '') : '';
}

// Date AAAAMMJJ du FEC -> JJ/MM/AAAA
export function displayDate(fecDate) {
    return fecDate ? `${fecDate.substring(6, 8)}/${fecDate.substring(4, 6)}/${fecDate.substring(0, 4)}` : '';
}

// Date AAAAMMJJ du FEC -> numéro de série Excel (jours depuis le 30/12/1899), indépendant du fuseau horaire
export function excelDate(fecDate) {
    if (!fecDate) return undefined;
    const utc = Date.UTC(Number(fecDate.substring(0, 4)), Number(fecDate.substring(4, 6)) - 1, Number(fecDate.substring(6, 8)));
    return Math.round(utc / 86400000) + 25569;
}

// Référence d'une pièce comme dans le FEC : FA0001, AC0001, AV0001
export function documentRef(prefix, number) {
    return prefix + String(number).padStart(4, '0');
}

// Montant en euros et taux de TVA : même mise en forme que dans le module achats
export const money = formatAmount;
export {formatRate};

// Un champ texte du FEC ne doit contenir ni tabulation, ni retour à la ligne, ni espace insécable
export function cleanText(value) {
    return String(value ?? '').replace(/[\s\u200b]+/g, ' ').trim();
}

// Mode de paiement des encaissements (virement, chèque, espèces) et des décaissements (+ carte bancaire, prélèvement)
export function paymentTypeLabel(paymentType) {
    return {CARD: 'Carte bancaire', DIRECT_DEBIT: 'Prélèvement'}[paymentType] ?? convertPaymentType(paymentType);
}

const CONTROL_COLUMN_LABELS = {
    date: 'Date', amount: 'Montant', paymentType: 'Mode', contractNumber: 'N° contrat',
    clientName: 'Client', supplierName: 'Fournisseur', pieceRef: 'Pièce', info: 'Détail',
};

export function controlColumnLabel(column) {
    return CONTROL_COLUMN_LABELS[column] || column;
}

export function controlCellValue(row, column) {
    const value = row[column];
    if (value === undefined || value === null || value === '') return '-';
    if (column === 'date') return displayDate(value);
    if (column === 'amount') return money(value);
    if (column === 'paymentType') return paymentTypeLabel(value);
    return value;
}
